// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 293 ? "component---src-pages-index-js" : chunkId) + "-" + {"293":"fb1a52fb89cf384f51e8","454":"c5ace5208c2fd6d818c2"}[chunkId] + ".js";
};